<template>
  <div
    :class="{
      'mx-auto w-52 lg:w-64': imageSize == 'large',
      'mx-auto w-full': imageSize == 'full',
      'mx-auto w-20 lg:w-28': imageSize == 'normal',
      'w-60px shrink-0': imageSize == 'inline',
    }">
    <img class="mx-auto" :src="image.url" :alt="image.description" />
  </div>
</template>

<script>
import { useCustomValidator } from "../../../compostables/useValidators";

export default {
  props: {
    image: {
      type: Object,
      required: true,
    },
    imageSize: {
      type: String,
      required: true,
      validator(value) {
        return useCustomValidator(["large", "full", "normal", "inline"], value);
      },
    },
  },
};
</script>
